'use client';

import { Heading } from '../../../../components/Heading/Heading';
import { PostImageGrid } from '../../../../components/PostImageGrid/PostImageGrid';

import { PostsViewer } from '../../../../components/PostsViewer/PostsViewer';
import { getNodesFromConnection } from '@graphql/connections/getNodesFromConnection';
import { useClientHasRendered } from '@domain/session/useClientHasRendered';
import { usePostViewer } from '@domain/posts/usePostViewer';
import { GetBrandPosts, BrandPostNodeFields } from '../../../../generated/graphql';

interface IProps {
  brandPosts: GetBrandPosts;
}

export const BrandPostsGrid = ({ brandPosts }: IProps) => {
  const totalGridPosts = 12;
  const clientHasRendered = useClientHasRendered();

  const {
    currentPostViewerId,
    closePostViewer,
    isPostViewerOpen,
    openPostViewer,
    setCurrentPostViewerId,
  } = usePostViewer();

  const posts = getNodesFromConnection<BrandPostNodeFields>(brandPosts.posts);
  const postsWithImages = posts.filter(p => p.images.totalCount > 0).slice(0, totalGridPosts);

  return (
    <section>
      <Heading variant="sm" className="mb-4">
        Recent Brand Posts
      </Heading>
      <PostImageGrid
        isLoading={!clientHasRendered}
        openPostViewer={openPostViewer}
        posts={postsWithImages}
      />
      {isPostViewerOpen && currentPostViewerId && (
        <PostsViewer
          posts={postsWithImages}
          currentPostViewerId={currentPostViewerId}
          hasMore={false}
          isPostViewerOpen
          loadMore={() => {}}
          onClosePostsViewer={closePostViewer}
          setCurrentPostViewerId={setCurrentPostViewerId}
        />
      )}
    </section>
  );
};
